export default "__VITE_ASSET__lvswjzcE__"